import { frontendURL } from '../../../../helper/URLHelper';
import RealEstateBrokerInvestmentsPage from '../pages/RealEstateBrokerInvestmentsPage.vue';
import RealEstateBrokerInvestmentDetailPage from '../pages/RealEstateBrokerInvestmentDetailPage.vue';
import RealEstateBrokerPaymentMethodsPage from '../pages/RealEstateBrokerPaymentMethodsPage.vue';
import RealEstateBrokerCommissionDetailPage from '../pages/RealEstateBrokerCommissionDetailPage.vue';
import RealEstateBrokerCommissionRequestPage from '../pages/RealEstateBrokerCommissionRequestPage.vue';
import RealEstateBrokerCommissionTaxDocumentPage from '../pages/RealEstateBrokerCommissionTaxDocumentPage.vue';
import RealEstateBrokerHelpPage from '../pages/RealEstateBrokerHelpPage.vue';
import RealEstateBrokerDashboardPage from '../pages/RealEstateBrokerDashboardPage.vue';
import { brokerDashboardPermissions } from './permissions';

export const brokerRoutes = [
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/corretor/investimentos/:investmentId'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/corretor/investimento/:investmentId'
      ),
      frontendURL('accounts/:accountId/corretor/investimento/:investmentId'),
    ],
    name: 'operacao_imobiliaria_corretor_investimento',
    component: RealEstateBrokerInvestmentDetailPage,
    meta: { permissions: brokerDashboardPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/corretor/:brokerId/:slug/:detailId'
    ),
    alias: [
      frontendURL('accounts/:accountId/corretor/:brokerId/:slug/:detailId'),
    ],
    name: 'operacao_imobiliaria_corretor_legacy_detail',
    redirect: to => {
      const routeBySlug = {
        investimento: {
          name: 'operacao_imobiliaria_corretor_investimento',
          params: { investmentId: to.params.detailId },
        },
        parcela: {
          name: 'operacao_imobiliaria_corretor_parcela',
          params: { installmentId: to.params.detailId },
        },
      };
      const target = routeBySlug[to.params.slug];

      return target
        ? {
            ...target,
            params: { accountId: to.params.accountId, ...target.params },
          }
        : {
            name: 'operacao_imobiliaria_corretor',
            params: { accountId: to.params.accountId },
          };
    },
    meta: { permissions: brokerDashboardPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/corretor/investimentos'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/corretor/investimento'
      ),
      frontendURL('accounts/:accountId/corretor/investimento'),
    ],
    name: 'operacao_imobiliaria_corretor_investimentos',
    component: RealEstateBrokerInvestmentsPage,
    meta: { permissions: brokerDashboardPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/corretor/parcelas/:installmentId/dados-pagamento'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/corretor/parcela/:installmentId/confirmar-dados-pagamento'
      ),
    ],
    name: 'operacao_imobiliaria_corretor_pagamento',
    component: RealEstateBrokerPaymentMethodsPage,
    meta: { permissions: brokerDashboardPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/corretor/parcelas/:installmentId'
    ),
    alias: [frontendURL('accounts/:accountId/corretor/parcela/:installmentId')],
    name: 'operacao_imobiliaria_corretor_parcela',
    component: RealEstateBrokerCommissionDetailPage,
    meta: { permissions: brokerDashboardPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/corretor/parcelas/:installmentId/solicitar-transferencia'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/corretor/parcela/:installmentId/solicitar-transferencia'
      ),
    ],
    name: 'operacao_imobiliaria_corretor_solicitar_transferencia',
    component: RealEstateBrokerCommissionRequestPage,
    meta: { permissions: brokerDashboardPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/corretor/parcelas/:installmentId/upload-nota'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/corretor/parcela/:installmentId/upload-nota'
      ),
    ],
    name: 'operacao_imobiliaria_corretor_nota',
    component: RealEstateBrokerCommissionTaxDocumentPage,
    meta: { permissions: brokerDashboardPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/corretor/ajuda'
    ),
    alias: [frontendURL('accounts/:accountId/corretor/ajuda')],
    name: 'operacao_imobiliaria_corretor_ajuda',
    component: RealEstateBrokerHelpPage,
    meta: { permissions: brokerDashboardPermissions },
  },
  {
    path: frontendURL('accounts/:accountId/operacao-imobiliaria/corretor'),
    alias: [
      frontendURL('accounts/:accountId/corretor'),
      frontendURL('accounts/:accountId/corretores'),
      frontendURL('accounts/:accountId/operacao-imobiliaria/painel-corretor'),
    ],
    name: 'operacao_imobiliaria_corretor',
    component: RealEstateBrokerDashboardPage,
    meta: { permissions: brokerDashboardPermissions },
  },
];
